import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Award } from "lucide-react";
import { EDUCATION, CERTIFICATIONS } from "../../data/content";

export default function ProEducation() {
  return (
    <div className="pt-24 pb-16" data-testid="pro-education">
      <section className="max-w-4xl mx-auto px-5 md:px-8">
        <p className="font-plexMono text-xs uppercase tracking-[0.2em] text-terracotta">
          Education
        </p>
        <h1 className="font-serif font-light text-4xl md:text-6xl text-neutral-900 mt-3">
          Where I learned.
        </h1>

        <div className="mt-14 space-y-6">
          {EDUCATION.map((edu, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="border border-neutral-200 rounded-2xl p-6 md:p-8 bg-white"
              data-testid={`pro-edu-${i}`}
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-neutral-100 flex items-center justify-center shrink-0">
                  <GraduationCap size={22} className="text-neutral-700" />
                </div>
                <div className="flex-1">
                  <p className="font-plexMono text-xs uppercase tracking-widest text-terracotta">
                    {edu.period}
                  </p>
                  <h2 className="font-serif text-2xl md:text-3xl text-neutral-900 mt-1 leading-tight">
                    {edu.school}
                  </h2>
                  <p className="font-plex text-neutral-700 mt-1">{edu.degree}</p>
                  <p className="font-plex text-sm text-neutral-500 mt-3">{edu.note}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CERTIFICATIONS */}
        <div className="mt-16">
          <p className="font-plexMono text-xs uppercase tracking-[0.2em] text-terracotta">
            Certifications
          </p>
          <h2 className="font-serif font-light text-3xl md:text-4xl text-neutral-900 mt-3">
            Continual learning.
          </h2>
          <div className="mt-8 space-y-3">
            {CERTIFICATIONS.map((c, i) => (
              <div
                key={i}
                className="border border-neutral-200 rounded-xl p-5 flex items-start gap-4 bg-white"
                data-testid={`pro-cert-${i}`}
              >
                <div className="w-10 h-10 rounded-lg bg-neutral-100 flex items-center justify-center shrink-0">
                  <Award size={20} className="text-neutral-700" />
                </div>
                <div>
                  <p className="font-plex font-medium text-neutral-900">{c.name}</p>
                  <p className="font-plexMono text-xs uppercase tracking-widest text-neutral-500 mt-1">
                    {c.issuer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
